export class AgGridSortFilterUtils {
  public static sortFilterColumn =  {
    comparator: (a: string, b: string) => {
      const valA = Number(a);
      const valB = Number(b);
      if (valA === valB) { return 0; };
      return valA > valB ? 1 : -1;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/core/ag-grid-utils/ag-grid-sort-filter-utils.ts